import React, { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import { toast, ToastContainer } from "react-toastify";
import { ApolloProvider } from "@apollo/client";
import App from "./components/container/App";
import client from "./services/graphql/apolloClient";
import { setSessionUUID } from "./utils/sessionUtils";
import { toastConfig as defaultToastConfig, notifyOfflineToastConfig } from "./utils/toastConfig";
import { useNavigatorOnline } from "./utils/hooks";

import "react-toastify/dist/ReactToastify.css";
import "antd/dist/reset.css";

const wrapper = document.getElementById("root");
setSessionUUID();

const notifyOffline = () => toast.info("You appear to have lost connection. Please check your network.", notifyOfflineToastConfig);
const closeOfflineToast = (toastId) => toast.dismiss(toastId);

// the app container provides toast and offline detecion capability to the app
const AppContainer = ({ children }) => {
  const { isOffline } = useNavigatorOnline();
  const offlineToastId = useRef(null);
  useEffect(() => {
    if (isOffline) {
      offlineToastId.current = notifyOffline();
    } else {
      closeOfflineToast(offlineToastId.current);
    }
  }, [isOffline]);

  return <div>{children}</div>;
};

const AppWithApolloAndToasts = () => (
  <ApolloProvider client={client}>
    <ToastContainer {...defaultToastConfig} />
    <AppContainer>
      <App />
    </AppContainer>
  </ApolloProvider>
);

if (!!wrapper) {
  createRoot(wrapper).render(<AppWithApolloAndToasts />);
}
